import { Box, Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";

interface EducationStepNavigationProps {
  onNext: () => void;
  onBack: () => void;
}

export function EducationStepNavigation(props: EducationStepNavigationProps) {
  const { onNext, onBack } = props;

  return (
    <Box sx={{ width: "100%", paddingX: 2 }}>
      <Stack
        direction="row"
        spacing={2}
        alignItems="center"
        justifyContent="space-between"
        sx={{ maxWidth: 500, margin: "0 auto" }}
      >
        <Button
          size="large"
          variant="outlined"
          sx={{ borderRadius: 999, height: 56, flex: 1, maxWidth: 220 }}
          onClick={onBack}
        >
          Back
        </Button>
        <Button
          size="large"
          variant="contained"
          sx={{ borderRadius: 999, height: 56, flex: 1, maxWidth: 220 }}
          onClick={onNext}
        >
          Next
        </Button>
      </Stack>
    </Box>
  );
}
